import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../store";
import axios from "axios";

let initialState = {
  isSubmitting: false,
  successMessage: null,
  error: null,
};

export const slice = createSlice({
  name: "structuralSpecification",
  initialState,
  reducers: {
    setSubmitting(state, action) {
      state.isSubmitting = action.payload;
    },
    setSuccess(state, action) {
      state.successMessage = action.payload;
      state.error = null;
    },
    hasError(state, action) {
      state.error = action.payload;
      state.successMessage = null;
    },
  },
});

export const { setSubmitting, setSuccess, hasError } = slice.actions;

export default slice.reducer;

export function submitStructuralSpecificationTicket(formData) {
  const API_URL = process.env.REACT_APP_API_URL || '';
  return async () => {
    dispatch(slice.actions.setSubmitting(true));
    try {
      const response = await axios.post(`${API_URL}/api/structural-spec-request`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      dispatch(slice.actions.setSuccess(response.data?.message || "Structural Specification ticket submitted"));
      return response;
    } catch (error) {
      console.error("Structural Specification ticket submit error", error);
      dispatch(slice.actions.hasError(error));
      throw error;
    } finally {
      dispatch(slice.actions.setSubmitting(false));
    }
  };
}

// Submit Structural Specification form and request docx generation (saved to sharepoint)
export function submitStructuralSpecAndDownloadDocx(payload) {
  const API_URL = process.env.REACT_APP_API_URL || '';
  const url = `${API_URL}/api/structural-spec/generate-docx`;
  return async () => {
    dispatch(slice.actions.setSubmitting(true));
    try {
      const response = await axios.post(url, payload);

      dispatch(slice.actions.setSuccess("Structural Specification document generated and saved to SharePoint."));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    } finally {
      dispatch(slice.actions.setSubmitting(false));
    }
  };
}
